module.exports = __webpack_public_path__ + "firestore-logo.png?62502baa5ec8a1d0fea7e67bd7d8a59d";